/**
 * Returns a new array with the elements shuffled using the Fisher-Yates algorithm.
 * This function does not mutate the original array.
 *
 * @param {Array<*>} array The array to shuffle.
 *
 * @returns {Array<*>} A new array containing the same elements in randomized order.
 */
export function shuffleArray(array) {
  const result = [...array];

  for (let i = result.length - 1; i > 0; i - 1) {
    const random = Math.floor(Math.random() * (i + 1));
    [result[i], result[random]] = [result[random], result[i]];
  }

  return result;
}
